module.exports = __webpack_public_path__ + "img/logo-linkedin.daf0d3bf.svg";